/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
import { PrimaryButton } from '../../common/TailwindComponents';
export var EnrollmentConfirmation = function EnrollmentConfirmation(_ref) {
  var contact = _ref.contact,
    goBackToFacesheet = _ref.goBackToFacesheet,
    plan = _ref.plan;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white flex flex-col justify-center items-center text-center p-4"
  }, /*#__PURE__*/React.createElement(Icon, {
    ariaLabel: "verified",
    color: "#117E15",
    icon: "IconCheckCircle",
    iconName: "verified",
    size: 48,
    className: "p-4"
  }), /*#__PURE__*/React.createElement("h1", {
    style: {
      margin: '0px 0px 1em'
    }
  }, /*#__PURE__*/React.createElement("strong", null, "Enrollment Request Sent!")), /*#__PURE__*/React.createElement("p", {
    className: "max-w-lg text-left"
  }, "Your enrollment request to the ", /*#__PURE__*/React.createElement("strong", null, plan.name), " for ", /*#__PURE__*/React.createElement("strong", null, contact.full_name), " has been sent! You'll receive a notification when the request has been approved."), /*#__PURE__*/React.createElement("p", {
    className: "max-w-lg text-left py-6"
  }, "To check the status of the request, visit the client's face sheet and look under \"Social Care Coverage\" in their \"Profile\". Forms completed in this enrollment request process will be added to \"Forms\" in the client face sheet."), /*#__PURE__*/React.createElement(PrimaryButton, {
    label: "Check Enrollment Request Status",
    "data-testid": "check-enrollment-request-status-btn",
    onClick: goBackToFacesheet
  }));
};
EnrollmentConfirmation.propTypes = {
  contact: PropTypes.object,
  goBackToFacesheet: PropTypes.func.isRequired,
  plan: PropTypes.object.isRequired
};
EnrollmentConfirmation.defaultProps = {
  contact: {}
};
//# sourceMappingURL=EnrollmentConfirmation.js.map